import { apiRequest } from './http';
import type { DraftDetail, DraftSummary } from './types';

export async function listDrafts(): Promise<DraftSummary[]> {
  const response = await apiRequest<{ items?: DraftSummary[] }>('/api/drafts');
  return response.items ?? [];
}

export async function getDraft(draftId: string): Promise<DraftDetail> {
  return apiRequest<DraftDetail>(`/api/drafts/${encodeURIComponent(draftId)}`);
}

export async function saveDraft(input: {
  draftId?: string;
  templateId: string;
  name?: string;
  step: string;
  values: Record<string, string>;
}): Promise<DraftSummary> {
  return apiRequest<DraftSummary>('/api/drafts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input)
  });
}

export async function deleteDraft(draftId: string): Promise<void> {
  await apiRequest<void>(`/api/drafts/${encodeURIComponent(draftId)}`, { method: 'DELETE' });
}
